module.exports = __webpack_public_path__ + "static/media/eja.297a2a31.png";